export default __webpack_public_path__ + "static/media/MariaDB-WindowsTaskScheduler-CreateBasicTaskWizard01.358e6d9f.png";